/** CSS class + font mapping for Indic locales. */
const LANG_CLASS = {
  hi: "lang-hi",
  mr: "lang-mr",
  te: "lang-te",
  ta: "lang-ta",
  bn: "lang-bn",
  kn: "lang-kn",
  ml: "lang-ml",
  pa: "lang-pa",
};

const LANG_FONT = {
  hi: "Noto Sans Devanagari, sans-serif",
  mr: "Noto Sans Devanagari, sans-serif",
  te: "Noto Sans Telugu, sans-serif",
  ta: "Noto Sans Tamil, sans-serif",
  bn: "Noto Sans Bengali, sans-serif",
  kn: "Noto Sans Kannada, sans-serif",
  ml: "Noto Sans Malayalam, sans-serif",
  pa: "Noto Sans Gurmukhi, sans-serif",
};

export function langClass(lang) {
  return LANG_CLASS[lang] || "";
}

export function langFontFamily(lang) {
  return LANG_FONT[lang] || "Inter, sans-serif";
}
